import React from 'react'
import styles from './Bio.module.css'
import { getGravatarURL } from '../utils/getGravatarURL'

function Bio(props) {
  let photoURL = getGravatarURL({
    email: "abhishekwl@protonmail.com",
    size: 256,
  })

  return (
    <div
      style={{alignItems: 'center'}}
      className={`
      ${styles.Bio}
      ${props.className || ''}
    `}>
      <img src={photoURL} alt="Me" style={{height: 164, width: 164}} />
      <p style={{marginTop: 24}}>
        <b style={{fontSize: 32}}>Abhishek WL</b>
        <br></br>
        Co-Founder and Backend Engineer at <b><a href="https://tvast.in">TVAST</a></b>;<br />
        Ex Google DSC Lead for Bangalore.
        <br></br>
        <br></br>
        <a href="https://github.com/abhishekwl">
          <img src="https://cdn.iconscout.com/icon/free/png-256/github-153-675523.png" alt="Github" style={{height: 36, width: 36, borderRadius: 0}} />
        </a>
        <a href="https://www.linkedin.com/in/abhishekwl/">
          <img src="https://image.flaticon.com/icons/svg/34/34227.svg" alt="LinkedIn" style={{height: 36, width: 36, borderRadius: 0}} />
        </a>
        <a href="https://gist.github.com/abhishekwl">
          <img src="https://image.flaticon.com/icons/svg/54/54776.svg" alt="Gist" style={{height: 36, width: 36, borderRadius: 0}} />
        </a>
        <a href="https://www.reddit.com/user/abhishekwl">
          <img src="https://cdns.iconmonstr.com/wp-content/assets/preview/2016/240/iconmonstr-reddit-4.png" alt="Reddit" style={{height: 36, width: 36, borderRadius: 0}} />
        </a>
        <a href="https://stackoverflow.com/users/5458915/abhishek-wl">
          <img src="https://image.flaticon.com/icons/png/512/36/36634.png" alt="Stack Overflow" style={{height: 36, width: 36, borderRadius: 0}} />
        </a>
        <br></br>
      </p>
    </div>
  )
}

export default Bio
